import { createSlice } from "@reduxjs/toolkit";
import { InitialStateConfigTransportadoras } from "../models/configTransportadoras.model";

const initialState: InitialStateConfigTransportadoras = {
  screenfilter: "",
  configTabs: {
    tabInView: 0,
    tabs: [
      {
        title: "Apelidos",
        index: 0,
        active: true,
        name: "apelidos",
      },
      {
        title: "Transportadoras",
        index: 1,
        active: true,
        name: "transportadoras",
      },
      {
        title: "Barrar entrega",
        index: 2,
        active: true,
        name: "barrarEntrega",
      },
    ],
  },
};

const configTransportadorasSlice = createSlice({
  name: "transportadorasApp/configTransportadoras",
  initialState,
  reducers: {
    changeTab: (state, action) => {
      state.configTabs.tabInView = action.payload;
    },
    setTabFilter: (state, action) => {
      state.screenfilter = action.payload;
    },
    clearFilter: (state) => {
      state.screenfilter = ''
    }
  },
});

export const {
  changeTab,
  setTabFilter,
  clearFilter
} = configTransportadorasSlice.actions;

export default configTransportadorasSlice.reducer;
